import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Button from '@components-clean/core/button';
import CoreCheckbox from '@components-clean/core/core-checkbox';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { DropDownListController } from '@components-clean/core/drop-down-list';
import { TextBoxController } from '@components-clean/core/text-box';
import { useBoolean } from '@hooks/index';

interface DummyFormInputs {
    active: boolean;
    name: string;
    panel: string | null;
    source: string | null;
}

const PanelsDummyData = ['Panel 1', 'Panel 2', 'Panel 3', 'Panel 4', 'Panel 5'];

const DialogWithInputsPage = () => {
    const isDialogOpened = useBoolean(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { isValid, isDirty },
    } = useForm<DummyFormInputs>({
        mode: 'all',
        defaultValues: {
            active: false,
            name: '',
            panel: null,
            source: null,
        },
    });

    const onClose = () => {
        isDialogOpened.setFalse();
        reset();
    };

    const onSubmit = (data: DummyFormInputs) => {
        /* eslint-disable-next-line no-console */
        console.log(data);
    };

    return (
        <>
            <Button onClick={isDialogOpened.toggle} data-testid="toggle-dialog-button" primary>
                Open Dialog
            </Button>
            {isDialogOpened.value && (
                <DraggableDialog
                    title="Dialog Title"
                    dataTestId="add-edit-dialog"
                    onClose={onClose}
                    onSubmit={() => handleSubmit(onSubmit)()}
                    primaryBtnLabel="Add"
                    secondaryBtnLabel="Cancel"
                    primaryBtnDisabled={!isValid || !isDirty}
                >
                    <form id="add-data-view-form" style={{ width: 726 }}>
                        <div className="k-mb-5.5">
                            <Controller
                                control={control}
                                name="active"
                                render={({ field: { onChange, value } }) => (
                                    <CoreCheckbox
                                        value={value}
                                        onChange={onChange}
                                        label="Active"
                                        data-testid="active-checkbox"
                                    />
                                )}
                            />
                        </div>
                        <div className="k-d-flex k-gap-15">
                            <div className="k-w-1/3">
                                <TextBoxController
                                    control={control}
                                    name="name"
                                    required
                                    data-testid="label-input"
                                    label="Text input *"
                                    maxLength={30}
                                    hintText="** Insert lots of interesting text here about Main Panel"
                                />
                            </div>
                            <div className="k-w-1/3">
                                <DropDownListController
                                    control={control}
                                    name="panel"
                                    data={PanelsDummyData}
                                    data-testid="field-select"
                                    className="!k-mb-5"
                                    label="Select 1 *"
                                    hintText="** Insert lots of interesting text here about Main Panel"
                                    required
                                />
                            </div>
                            <div className="k-w-1/3">
                                <DropDownListController
                                    control={control}
                                    name="source"
                                    data-testid="field-select"
                                    data={PanelsDummyData}
                                    className="!k-mb-5"
                                    label="Select 2 *"
                                    hintText="** Insert lots of interesting text here about Main Panel"
                                    required
                                />
                            </div>
                        </div>
                    </form>
                </DraggableDialog>
            )}
        </>
    );
};

export default DialogWithInputsPage;
